(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('FileDetailController', FileDetailController);

    FileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'File'];

    function FileDetailController($scope, $rootScope, $stateParams, entity, File) {
        var vm = this;

        vm.file = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:fileUpdate', function(event, result) {
            vm.file = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
